import { httpClient, HttpMethod } from './http-client';
import { VisibilityRule, CurrentUserVisibilityRuleAccess } from '../@types/visibilityRule.type';

export const getVisibilityRules = (): Promise<VisibilityRule[]> => {
  return httpClient<VisibilityRule[]>('/visibilityrules', HttpMethod.Get);
};

export const getVisibilityRuleById = (id: number): Promise<VisibilityRule> => {
  return httpClient<VisibilityRule>(`/visibilityrules/${id}`, HttpMethod.Get);
};

export const getCurrentUserVisibility = (): Promise<CurrentUserVisibilityRuleAccess> => {
  return httpClient<CurrentUserVisibilityRuleAccess>('/getVisibilityRuleAccess', HttpMethod.Get);
};
